<form class="check-lists-filters" [formGroup]="filtersForm">
  <div class="check-lists-filters__rows">
    <app-select
      formControlName="category"
      #select
      class="check-lists-filters__category"
      [items]="categories"
      [defaultText]="'Все'"
      [nullChoice]="true"
      (callback)="handleChangeCategory($event)"
      [textKey]="'name'"
      [name]="'CheckListCategory'"
    ></app-select>
  </div>

  <div class="check-lists-filters__rows">
    <app-field class="check-lists-filters__keyword">
      <input type="text" class="input-text" placeholder="Введите ключевое слово" formControlName="search" />
    </app-field>
    <button type="button" class="button check-lists-list__button check-lists-filters__apply" (click)="handleApply()">Применить</button>
    <a class="link link--dotted-blue-dark check-lists-filters__link" (click)="handleReset(); select.onReset()"> Сбросить </a>

    <button type="button" class="button check-lists-list__button check-lists-filters__create" (click)="handleCreate()">
      <app-icon [size]="'10'" [glyph]="'add'" class="check-lists-filters__create-icon"></app-icon>
      Добавить вопрос
    </button>
  </div>
</form>
